// Fragment "bookingServices" — ServicesAdmin.jsx (the catalogue of priced booking
// services), plus `cal.priceFree`, the price label every admin surface that lists those
// services shows for a free one. Convention: flat dotted keys, values in all three
// languages, never empty.
export default {
  fr: {
    "bookingServices.pricingModeLabel": "Mode de tarification",
    "bookingServices.deliveryModeLabel": "Lieu de la séance",
    "bookingServices.deliveryInPerson": "Au cabinet",
    "bookingServices.deliveryVideo": "Visioconsultation",
    "bookingServices.deliveryInPersonHint": "Le client se déplace au cabinet.",
    "bookingServices.deliveryVideoHint": "Le client rejoint une salle vidéo à l\u2019heure du rendez-vous, pour la durée réservée. Le paiement se fait à la réservation, comme pour tout autre service.",
    "bookingServices.perMinuteBadge": "À la minute",
    "bookingServices.priceIgnoredPerMinute": "Le tarif vient des réglages de téléconsultation (tarif à la minute, minimum, plafond, frais de base) et de la devise de règlement — ce prix n’est pas utilisé.",
    "bookingServices.pricingModeFixed": "Prix fixe",
    "bookingServices.pricingModePerMinute": "À la minute (téléconsultation)",
    "bookingServices.pricingModeFixedHint": "Le prix du catalogue est encaissé à la réservation.",
    "bookingServices.pricingModePerMinuteHint": "Le prix du catalogue est ignoré : une empreinte est autorisée à la réservation et seule la durée réelle est encaissée. Nécessite un tarif à la minute actif dans Téléconsultation.",
    "bookingServices.perMinuteNoRate": "Aucun tarif à la minute n'est actif : ce service peut être enregistré, mais une réservation échouera tant que le tarif n'est pas défini.",
    "bookingServices.perMinuteNoRateLink": "Définir le tarif à la minute",
    "nav.bookingServices": "Services",
    "bookingServices.title": "Services de réservation",
    "bookingServices.subtitle": "Définissez les services tarifés que vos heures d'ouverture proposent. La durée d'un service est celle de ses rendez-vous.",
    "bookingServices.new": "Nouveau service",
    "bookingServices.empty": "Aucun service pour le moment.",
    "bookingServices.nameLabel": "Nom",
    "bookingServices.namePlaceholder": "Ex : Massage suédois",
    "bookingServices.descriptionLabel": "Description",
    "bookingServices.durationLabel": "Durée (min)",
    "bookingServices.priceLabel": "Prix ($)",
    "bookingServices.currencyLabel": "Devise",
    "bookingServices.activeLabel": "Actif",
    "bookingServices.free": "Gratuit",
    "bookingServices.activate": "Activer",
    "bookingServices.deactivate": "Désactiver",
    "bookingServices.confirmDelete": "Supprimer ce service ?",
    "bookingServices.nameRequired": "Nom requis",
    "bookingServices.priceOutOfRange": "Entrez un prix entre 0 et {max}.",
    "bookingServices.toast.saved": "Service enregistré",
    "bookingServices.toast.deactivated": "Service désactivé (encore utilisé par vos heures d'ouverture ou des rendez-vous)",
    "bookingServices.toast.deleted": "Service supprimé",
    "bookingServices.toast.error": "Erreur",
    "cal.priceFree": "Gratuit",
  },
  en: {
    "bookingServices.pricingModeLabel": "Pricing mode",
    "bookingServices.deliveryModeLabel": "Where it takes place",
    "bookingServices.deliveryInPerson": "At the practice",
    "bookingServices.deliveryVideo": "Video consultation",
    "bookingServices.deliveryInPersonHint": "The client comes to the practice.",
    "bookingServices.deliveryVideoHint": "The client joins a video room at the appointment time, for the booked length. Payment is taken at booking, like any other service.",
    "bookingServices.perMinuteBadge": "Per minute",
    "bookingServices.priceIgnoredPerMinute": "The rate comes from your telehealth settings (per-minute rate, minimum, cap, base fee) and the settlement currency — this price is not used.",
    "bookingServices.pricingModeFixed": "Fixed price",
    "bookingServices.pricingModePerMinute": "Per minute (telehealth)",
    "bookingServices.pricingModeFixedHint": "The catalogue price is charged at booking.",
    "bookingServices.pricingModePerMinuteHint": "The catalogue price is ignored: a hold is authorised at booking and only the real duration is captured. Requires an active per-minute rate under Telehealth.",
    "bookingServices.perMinuteNoRate": "No per-minute rate is active: this service saves fine, but a booking will fail until the rate is set.",
    "bookingServices.perMinuteNoRateLink": "Set the per-minute rate",
    "nav.bookingServices": "Services",
    "bookingServices.title": "Booking services",
    "bookingServices.subtitle": "Define the priced services your opening hours offer. A service's duration is the length of its appointments.",
    "bookingServices.new": "New service",
    "bookingServices.empty": "No services yet.",
    "bookingServices.nameLabel": "Name",
    "bookingServices.namePlaceholder": "E.g. Swedish massage",
    "bookingServices.descriptionLabel": "Description",
    "bookingServices.durationLabel": "Duration (min)",
    "bookingServices.priceLabel": "Price ($)",
    "bookingServices.currencyLabel": "Currency",
    "bookingServices.activeLabel": "Active",
    "bookingServices.free": "Free",
    "bookingServices.activate": "Activate",
    "bookingServices.deactivate": "Deactivate",
    "bookingServices.confirmDelete": "Delete this service?",
    "bookingServices.nameRequired": "Name required",
    "bookingServices.priceOutOfRange": "Enter a price between 0 and {max}.",
    "bookingServices.toast.saved": "Service saved",
    "bookingServices.toast.deactivated": "Service deactivated (still used by your opening hours or appointments)",
    "bookingServices.toast.deleted": "Service deleted",
    "bookingServices.toast.error": "Error",
    "cal.priceFree": "Free",
  },
  es: {
    "bookingServices.pricingModeLabel": "Modo de tarificación",
    "bookingServices.deliveryModeLabel": "Dónde se realiza",
    "bookingServices.deliveryInPerson": "En la consulta",
    "bookingServices.deliveryVideo": "Videoconsulta",
    "bookingServices.deliveryInPersonHint": "El cliente acude a la consulta.",
    "bookingServices.deliveryVideoHint": "El cliente entra en una sala de vídeo a la hora de la cita, durante el tiempo reservado. El pago se realiza al reservar, como en cualquier otro servicio.",
    "bookingServices.perMinuteBadge": "Por minuto",
    "bookingServices.priceIgnoredPerMinute": "La tarifa proviene de los ajustes de teleconsulta (tarifa por minuto, mínimo, tope, tarifa base) y de la moneda de liquidación — este precio no se utiliza.",
    "bookingServices.pricingModeFixed": "Precio fijo",
    "bookingServices.pricingModePerMinute": "Por minuto (teleconsulta)",
    "bookingServices.pricingModeFixedHint": "El precio del catálogo se cobra al reservar.",
    "bookingServices.pricingModePerMinuteHint": "El precio del catálogo se ignora: se autoriza una retención al reservar y solo se cobra la duración real. Requiere una tarifa por minuto activa en Teleconsulta.",
    "bookingServices.perMinuteNoRate": "No hay ninguna tarifa por minuto activa: este servicio se guarda, pero una reserva fallará hasta que se defina la tarifa.",
    "bookingServices.perMinuteNoRateLink": "Definir la tarifa por minuto",
    "nav.bookingServices": "Servicios",
    "bookingServices.title": "Servicios de reserva",
    "bookingServices.subtitle": "Defina los servicios con precio que ofrecen sus horas de apertura. La duración de un servicio es la de sus citas.",
    "bookingServices.new": "Nuevo servicio",
    "bookingServices.empty": "Aún no hay servicios.",
    "bookingServices.nameLabel": "Nombre",
    "bookingServices.namePlaceholder": "Ej.: Masaje sueco",
    "bookingServices.descriptionLabel": "Descripción",
    "bookingServices.durationLabel": "Duración (min)",
    "bookingServices.priceLabel": "Precio ($)",
    "bookingServices.currencyLabel": "Moneda",
    "bookingServices.activeLabel": "Activo",
    "bookingServices.free": "Gratis",
    "bookingServices.activate": "Activar",
    "bookingServices.deactivate": "Desactivar",
    "bookingServices.confirmDelete": "¿Eliminar este servicio?",
    "bookingServices.nameRequired": "Nombre requerido",
    "bookingServices.priceOutOfRange": "Ingrese un precio entre 0 y {max}.",
    "bookingServices.toast.saved": "Servicio guardado",
    "bookingServices.toast.deactivated": "Servicio desactivado (aún usado por sus horas de apertura o por citas)",
    "bookingServices.toast.deleted": "Servicio eliminado",
    "bookingServices.toast.error": "Error",
    "cal.priceFree": "Gratis",
  },
};
